import { ValueIs } from './ValueIs';
export class ValueIsProperty {
    ValueIs: ValueIs;
    PropertyName: string;
}
